// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// FontAwesome
import { registerFontAwesome } from './plugins/fontawesome'

// Vuetify
import { createThemedVuetify } from './plugins/vuetify'

import '@/assets/styles/global.css'

// CKEditor do VUe
import '@vueup/vue-quill/dist/vue-quill.snow.css'

// Cria app Vue
const app = createApp(App)

// Configurações de segurança e endpoint (do .env)
const chaveSeguranca = process.env.VUE_APP_CHAVE_SEGURANCA
const endpoint = process.env.VUE_APP_BASE_ENDPOINT
const apiKeyMaps = process.env.VUE_APP_GOOGLE_KEY
const cidadeCliente = process.env.VUE_APP_CIDADE_CLIENTE
const estadoCliente = process.env.VUE_APP_ESTADO_CLIENTE
const usuarioSeguranca = {
  user: process.env.VUE_APP_USUARIO,
  password: process.env.VUE_APP_PASSWORD
}

// Injeta valores globais via provide
app.provide('chaveSeguranca', chaveSeguranca)
app.provide('endpoint', endpoint)
app.provide('headerPadrao', { 'Content-Type': 'application/json' })
app.provide('usuarioSeguranca', usuarioSeguranca)
app.provide('apiKeyMaps', apiKeyMaps)
app.provide('cidadeCliente', cidadeCliente)
app.provide('estadoCliente', estadoCliente)

// Exposição via globalProperties (this.$...)
app.config.globalProperties.$chaveSeguranca = chaveSeguranca
app.config.globalProperties.$endpoint = endpoint
app.config.globalProperties.$headerPadrao = { 'Content-Type': 'application/json' }
app.config.globalProperties.$usuarioSeguranca = usuarioSeguranca
app.config.globalProperties.$grupoDestinatarioGeoreferenciado = 1;
app.config.globalProperties.$grupoDestinatarioPadrao = 2;
app.config.globalProperties.$grupoDestinatarioManual = 3;

// Registro global do componente FontAwesome
registerFontAwesome(app)

// Instância Vuetify com tema dinâmico (light/dark) conforme armazenamento
const themeMode = localStorage.getItem('themeMode') || 'light'
const vuetify = createThemedVuetify(themeMode)

// Uso de plugins e montagem do app
app
  .use(router)
  .use(vuetify)
  .mount('#app')
